import { Badge } from "@/components/ui/badge";
import type { ReactElement } from "react";
import {
    Clock,
    UserCheck,
    Loader,
    RotateCcw,
    CalendarClock,
    SearchCheck,
    CheckCircle2,
    BadgeCheck,
    XCircle,
} from "lucide-react";
import { appointment_status } from "@/models/appointment.model";

const map: Record<appointment_status, { label: string; icon: ReactElement; color: string }> = {
    pending: {
        label: "Pending",
        icon: <Clock className="w-3 h-3 mr-1" />,
        color: "bg-gray-100 text-gray-800",
    },
    assigned: {
        label: "Assigned",
        icon: <UserCheck className="w-3 h-3 mr-1" />,
        color: "bg-indigo-100 text-indigo-800",
    },
    accepted: {
        label: "Accepted",
        icon: <CheckCircle2 className="w-3 h-3 mr-1" />,
        color: "bg-lime-100 text-lime-800",
    },
    inprogress: {
        label: "In Progress",
        icon: <Loader className="w-3 h-3 mr-1 animate-spin" />,
        color: "bg-blue-100 text-blue-800",
    },
    goback: {
        label: "Go Back",
        icon: <RotateCcw className="w-3 h-3 mr-1" />,
        color: "bg-yellow-100 text-yellow-800",
    },
    rescheduled: {
        label: "Rescheduled",
        icon: <CalendarClock className="w-3 h-3 mr-1" />,
        color: "bg-orange-100 text-orange-800",
    },
    inspected: {
        label: "Inspected",
        icon: <SearchCheck className="w-3 h-3 mr-1" />,
        color: "bg-teal-100 text-teal-800",
    },
    done: {
        label: "Done",
        icon: <CheckCircle2 className="w-3 h-3 mr-1" />,
        color: "bg-green-100 text-green-800",
    },
    completed: {
        label: "Completed",
        icon: <BadgeCheck className="w-3 h-3 mr-1" />,
        color: "bg-emerald-100 text-emerald-800",
    },
    cancelled: {
        label: "Cancelled",
        icon: <XCircle className="w-3 h-3 mr-1" />,
        color: "bg-red-100 text-red-800",
    },
};

export const APPOINTMENT_STATUS_OPTIONS = (Object.keys(map) as appointment_status[]).map((value) => ({ value, label: map[value].label }));

export default function AppointmentStatusBadge({status}: {status: appointment_status}) {
    const item = map[status];

    if (!item) return <Badge variant="outline">{status}</Badge>;

    return (
        <span className={`inline-flex items-center text-xs font-medium px-2 py-1 rounded-sm w-fit min-w-32 justify-center ${item.color}`}>
            {item.icon} {item.label}
        </span>
    );
}
